import type { FeatureCollection } from 'geojson'

export type RouteOddElement = {
  type: string
  lat?: number | null
  lng?: number | null
  location?: { latitude: number | null; longitude: number | null } | null
}

export type OddLayerElement = {
  taxonomy: string
  elementType: string | null | undefined
  location: { latitude: number; longitude: number } | null | undefined
}

const getRouteOddCoordinates = (element: RouteOddElement) => {
  const latitude = element.lat ?? element.location?.latitude
  const longitude = element.lng ?? element.location?.longitude

  if (latitude == null || longitude == null) return null

  return { latitude, longitude }
}

const getCoordinateKey = (longitude: number, latitude: number) =>
  `${longitude.toFixed(6)},${latitude.toFixed(6)}`

export const buildOddFeatureCollection = (
  type: string,
  elements: OddLayerElement[],
  routeOddElements: RouteOddElement[],
): FeatureCollection => {
  const routeCoordSet = new Set(
    routeOddElements
      .filter(routeElement => routeElement.type === type)
      .map(getRouteOddCoordinates)
      .filter(
        (coordinates): coordinates is { latitude: number; longitude: number } =>
          coordinates != null,
      )
      .map(({ latitude, longitude }) => getCoordinateKey(longitude, latitude)),
  )

  return {
    type: 'FeatureCollection',
    features: elements
      .filter(element => element.location)
      .map(element => {
        const longitude = element.location!.longitude
        const latitude = element.location!.latitude

        return {
          type: 'Feature' as const,
          properties: {
            oddType: element.elementType ?? type,
            renderFullOpacity: routeCoordSet.has(
              getCoordinateKey(longitude, latitude),
            ),
          },
          geometry: {
            type: 'Point' as const,
            coordinates: [longitude, latitude],
          },
        }
      }),
  }
}
